module.exports = __webpack_public_path__ + "bce9026e79240efb4ff9d3606ba5c012.otf";